var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[(_vm.businessTemplate === 'avalon')?_c('avalonNewsSingle',{key:"Avalon",attrs:{"alias":_vm.alias,"news-alias":_vm.newsAlias}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }